/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Upgrade_Plan_Modal_Upgrade_ButtonInputs */

const es_components_upgrade_plan_modal_upgrade_button = /** @type {(inputs: Components_Upgrade_Plan_Modal_Upgrade_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar Plan`)
};

const en_components_upgrade_plan_modal_upgrade_button = /** @type {(inputs: Components_Upgrade_Plan_Modal_Upgrade_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade Plan`)
};

/**
* | output |
* | --- |
* | "Upgrade Plan" |
*
* @param {Components_Upgrade_Plan_Modal_Upgrade_ButtonInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_upgrade_plan_modal_upgrade_button = /** @type {((inputs?: Components_Upgrade_Plan_Modal_Upgrade_ButtonInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Upgrade_Plan_Modal_Upgrade_ButtonInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_upgrade_plan_modal_upgrade_button(inputs)
	return en_components_upgrade_plan_modal_upgrade_button(inputs)
});
export { components_upgrade_plan_modal_upgrade_button as "components.upgrade_plan_modal.upgrade_button" }